import api from "../utils/api";

export const virtualAccountService = {
  async checkExistingAccount() {
    const response = await api.get("/virtual-accounts");
    return response.data;
  },

  async createVirtualAccount() {
    const response = await api.post("/virtual-accounts");
    return response.data;
  },
};
